module.exports = __webpack_public_path__ + "static/media/goodgameshelf.1af4ffc4.png";